import App from '@/app'

const animateObserver = new IntersectionObserver(entries => {
	entries.forEach(entry => {

		if(entry.isIntersecting) {
			const classList = (entry.target.dataset.animate || 'animated fadeInUp').split(' ')
			const animationEnd = () => {
				entry.target.removeAttribute('data-animate')

				classList.forEach(className => entry.target.classList.remove(className))

				removeAnimation()
			}
			const removeAnimation = () => entry.target.removeEventListener('animationend', animationEnd, false)

			classList.forEach(className => entry.target.classList.add(className))

			entry.target.addEventListener('animationend', animationEnd, false)

			animateObserver.unobserve(entry.target)
		}

	})
}, {
	root: null,
	threshold: [ .1,.2,.3,.4,.5,.6,.7,.8,.9,1 ]
})

App.directive('animate', (el, binding) => {
	if(binding.arg === 'child') {
		[].slice.call(el.children).forEach(child => {

			child.dataset.animate = el.dataset.animate
			animateObserver.observe(child)
		})

		el.removeAttribute('data-animate')
	}

	else {
		animateObserver.observe(el)
	}
})
